import { render, staticRenderFns } from "./Receipt-detail.vue?vue&type=template&id=11bef0a6"
import script from "./Receipt-detail.vue?vue&type=script&lang=js"
export * from "./Receipt-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports